<div class="group-chat-box">
  <!-- Header (only shown on mobile) -->
  @if (showHeader) {
    <div class="chat-header">
      <div class="group-info">
        <div class="avatar-container">
          <img [src]="groupImageUrl || 'assets/images/placeholder.png'" [appDefaultImage]="'assets/images/placeholder.png'" alt="group" loading="eager" />
        </div>
        <div class="info">
          <h4 class="group-name">{{ groupName }}</h4>
          <p class="members-count">{{ selectedConversationGroupParticipants?.length || 0 }} <span translate>Members</span></p>
        </div>
      </div>
      @if (selectedConversationGroupParticipants && selectedConversationGroupParticipants.length) {
        <div class="participants">
          <div class="participant-avatars">
            @for (user of selectedConversationGroupParticipants | slice: 0 : 5; track user.id) {
              <div class="avatar-image" [tippy]="user.fullName">
                <img [appFetchProfileImage]="user.memberId" alt="" src="assets/images/placeholder.png" />
              </div>
            }
            @if (selectedConversationGroupParticipants.length > 5) {
              <div class="participant-count-badge">+{{ selectedConversationGroupParticipants.length - 5 }}</div>
            }
          </div>
        </div>
      }
    </div>
  }

  <!-- Messages -->
  <div #chatPanel class="chat-messages">
    @if (!loadings.messages) {
      @if (selectedConversationChatMessages.length) {
        @for (message of selectedConversationChatMessages; track message.id; let i = $index) {
          @if (isNewDate(message.message.timestamp, i)) {
            <div class="date-separator">
              <span>{{ message.message.timestamp | friendlyDate: true }}</span>
            </div>
          }
          <div [class.sender-wrapper]="!message.isMine" class="message-wrapper">
            @if (!message.isMine) {
              <div class="sender-avatar">
                @if (isUserFirstMessage(i)) {
                  <img [appFetchProfileImage]="getGroupParticipantMemberId(message)" alt="avatar" src="assets/images/placeholder.png" />
                }
              </div>
            }
            <div class="info-message">
              @if (!message.isMine && isUserFirstMessage(i)) {
                <h4 class="sender-name">{{ getGroupParticipantName(message) }}</h4>
              }
              <div [class.first-message]="isUserFirstMessage(i)" [class.--no-background]="isImage(message.message.message)" class="{{ message.isMine ? 'message' : 'sender-message' }}">
                @if (isAllowedToDeleteMessage || message?.isMine) {
                  <div (click)="deleteChatMessage(message)" class="delete-message-icon{{ !message.isMine ? '--received' : '' }}">
                    <app-icon [cssStyle]="{ cursor: 'pointer' }" [planeIcon]="true" iconName="trash" size="18px"></app-icon>
                  </div>
                }
                @if (message.message.messageType === ChatMessageType.Text) {
                  <p>{{ message.message.message }}</p>
                }
                @if (message.message.messageType === ChatMessageType.Image) {
                  @if (isImage(message.message.message)) {
                    <div class="image-message">
                      <div (click)="openImagePreview(message.message.message)" class="image-message__image-wrapper">
                        <img [src]="message?.message?.message || 'assets/images/no-image.png'" alt="" appDefaultImage loading="lazy" />
                      </div>
                      @if (message.message?.text?.message) {
                        <p>{{ message.message?.text?.message || '' }}</p>
                      }
                    </div>
                  } @else {
                    <div class="doc-message">
                      <div (click)="downloadDocument(message.message.message)" [tippy]="'Click to download'" class="doc-message__doc-wrapper">
                        <app-icon [planeIcon]="true" iconName="document-file" size="22px"></app-icon>
                        <small>{{ getDocFileName(message.message.message) }}</small>
                      </div>
                      @if (message.message?.text?.message) {
                        <p>{{ message.message?.text?.message || '' }}</p>
                      }
                    </div>
                  }
                }
                <span class="time">{{ message.message.timestamp | date: 'HH:mm' }}</span>
              </div>
            </div>
          </div>
        }
      } @else {
        <div class="no-messages">
          <p translate>messages.no messages yet</p>
          <span translate>messages.start the conversation</span>
        </div>
      }
    } @else {
      @for (_ of [].constructor(5); track $index + Math.random()) {
        <div class="skeleton-message">
          <ngx-skeleton-loader [theme]="{ height: '35px', width: '60%' }" count="1"></ngx-skeleton-loader>
        </div>
        <div class="skeleton-message --right">
          <ngx-skeleton-loader [theme]="{ height: '35px', width: '50%' }" count="1"></ngx-skeleton-loader>
        </div>
      }
    }
  </div>

  <!-- Input -->
  <div class="chat-input">
    <div class="attachment-option">
      <app-icon (click)="openFileSelector()" [cssStyle]="{ cursor: 'pointer', 'margin-top': '2px' }" [planeIcon]="true" iconName="paper-clip" size="18px"></app-icon>
    </div>
    <input (keyup.enter)="sendMessage()" [(ngModel)]="messageInput" [disabled]="isLoading" [placeholder]="'messages.write a message' | translate" class="input" type="text" />
    @if (messageInput || selectedAttachment) {
      @if (isLoading) {
        <app-icon color="var(--orange)" fill="none" iconName="spinner" [isSpinner]="true" size="18px"></app-icon>
      }
      @if (!isLoading) {
        <app-icon (click)="sendMessage()" [cssStyle]="{ cursor: 'pointer' }" [planeIcon]="true" iconName="send" size="18px"></app-icon>
      }
    }
    @if (selectedAttachment) {
      <div class="file-previewer">
        @if (selectedImagePreviewUrl) {
          <div class="image-preview">
            <img [src]="selectedImagePreviewUrl" alt="selected-image" />
            <button (click)="removeAttachment()" class="button-icon-only rounded-button">
              <app-icon [cssStyle]="{ cursor: 'pointer' }" [planeIcon]="true" iconName="close" marginTop="3px" size="16px"></app-icon>
            </button>
          </div>
        }
        @if (!selectedImagePreviewUrl) {
          <div class="document-preview">
            <app-icon [planeIcon]="true" iconName="document-file" size="22px"></app-icon>
            <p>{{ selectedAttachment.name | truncateText: 20 }}</p>
            <button (click)="removeAttachment()" class="button-icon-only rounded-button">
              <app-icon [cssStyle]="{ cursor: 'pointer' }" [planeIcon]="true" iconName="close" marginTop="3px" size="16px"></app-icon>
            </button>
          </div>
        }
      </div>
    }

    @if (showLightBox) {
      <app-lightbox-gallery (hide)="showLightBox = false" [images]="attachmentImages"></app-lightbox-gallery>
    }
  </div>
</div>
